import React from "react"
import { container, link } from "../styles/social-media-buttons.module.scss"
import facebook from "../images/social_media/facebook.png"
import instagram from "../images/social_media/instagram.png"
import linkedin from "../images/social_media/linkedin.png"
import mail from "../images/social_media/mail.png"

const SocialMediaButtons = () => {
  return (
    <div className={container}>
      <a href="mailto:kontakt@debacode.de" className={link}>
        <img src={mail} alt="Mail" />
      </a>
      <a
        href="https://www.linkedin.com/organization-guest/company/debacode"
        className={link}
      >
        <img src={linkedin} alt="LinkedIn" />
      </a>
      <a href="https://www.instagram.com/debacode/" className={link}>
        <img src={instagram} alt="Instagram" />
      </a>
      <a href="https://www.facebook.com/debacode" className={link}>
        <img src={facebook} alt="Facebook" />
      </a>
    </div>
  )
}

export default SocialMediaButtons
